module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/community-29473bd9046c30d6f1bd7c705d9c5770.svg";